import { useState } from 'react';
import { Link } from 'react-router-dom';
import { liveSessions } from '@/mocks/lives';
import SectionHeading from '@/components/feature/SectionHeading';
import ScheduleRow from '@/components/feature/ScheduleRow';

const categories = ['全部', ...Array.from(new Set(liveSessions.map((item) => item.category)))];

export default function TodaySchedule() {
  const [active, setActive] = useState('全部');

  const sorted = [...liveSessions].sort((a, b) => a.start.localeCompare(b.start));
  const filtered = active === '全部' ? sorted : sorted.filter((item) => item.category === active);
  const visible = filtered.slice(0, 6);

  return (
    <section id="today" className="w-full bg-background-50 py-12 md:py-16">
      <div className="container-page">
        <SectionHeading
          eyebrow="今日直播排期"
          title="今天一天播什么，按时间轴排给你看"
          desc="从早间爆料速递到深夜电竞，全天场次按开播时间顺序排列，正在直播、即将开始与已结束一眼区分。"
          action={
            <Link
              to="/schedule"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              完整排期
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          }
        />

        <div className="mb-6 flex flex-wrap gap-2">
          {categories.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setActive(item)}
              className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                active === item
                  ? 'border-primary-500 bg-primary-500 font-medium text-background-50'
                  : 'border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700'
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        {visible.length > 0 ? (
          <ul className="max-w-4xl">
            {visible.map((session) => (
              <ScheduleRow key={session.id} session={session} />
            ))}
          </ul>
        ) : (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-100 px-5 py-10 text-center text-sm text-foreground-500">
            该栏目今天暂无排期，换个分类看看，或者订阅提醒接收后续场次通知。
          </p>
        )}

        {filtered.length > visible.length && (
          <p className="mt-6 text-sm text-foreground-500">
            还有 {filtered.length - visible.length} 场未显示，
            <Link to="/schedule" className="font-medium text-primary-700 hover:text-primary-800">
              前往完整排期页
            </Link>
            查看全部安排。
          </p>
        )}
      </div>
    </section>
  );
}